module.exports = __webpack_public_path__ + "img/单图形烫金.fc935853.png";